var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("url") },
                    model: {
                      value: _vm.data.Url,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Url", $$v)
                      },
                      expression: "data.Url",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("title"),
                      disabled: !_vm.data.ShowTitle,
                    },
                    model: {
                      value: _vm.data.Title,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Title", $$v)
                      },
                      expression: "data.Title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { fancy: "", label: _vm.$ct("show-title") },
                    model: {
                      value: _vm.data.ShowTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "ShowTitle", $$v)
                      },
                      expression: "data.ShowTitle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: !_vm.data.NoBorder,
                      fancy: "",
                      label: _vm.$ct("border"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.data.NoBorder = !$event
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _vm.isDevMode
                    ? _c("w-checkbox", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("only-visible-for-support"),
                        },
                        model: {
                          value: _vm.item.OnlyVisibleForAdmin,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "OnlyVisibleForAdmin", $$v)
                          },
                          expression: "item.OnlyVisibleForAdmin",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("use-winfakt-desktop-server-as-proxy"),
                    },
                    model: {
                      value: _vm.data.UseDesktopAppAsProxy,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "UseDesktopAppAsProxy", $$v)
                      },
                      expression: "data.UseDesktopAppAsProxy",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }